<template>
  <div :class="$style.pageWrapper">
    <transition name="fade" v-for="(popup, index) in popupList" :key="popup.title">
      <LevelPopup
        v-if="currentPopupId===index"
        ref="popup"
        :title="popup.title"
        :description="popup.description"
        :steps="popup.steps"
        :showPoints="index===6"
        :numberOfPoints="numberOfPoints"
        :hideButton="index===6"
        :showCertificate="index===6"
        :btnText="index===5 ? 'Продолжить' : null"
        @close="closePopupHandler(index)"
        @share="() => $vk.shareDefault({ image: 'photo-174311295_457241386' })"
      >
        <slot v-if="index === 5">
          <div class="videoPopup__inner" style="position: relative; padding-bottom: 56.25%; height: 0;"><iframe src="https://www.loom.com/embed/eb8edeb4e9ec485a823a75b73bb9cf88" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe></div>
        </slot>
      </LevelPopup>
    </transition>
    <Points :numberOfPoints="numberOfPoints" :position="pointsPosition"/>
    <HelpBox
      ref="helpbox"
      :type="helpBoxType"
      :description="(numberOfTask < 4 && helpBoxType === 'warning') ? customWarning : helpBoxText[numberOfTask-1][helpBoxType]"
      :show="showHelpBox"
      @open="showHelpBox=true"
      @close="showHelpBox=false"
      @showNextTask="showNextTask"
      @closeWarning="closeWarning"
      :warnMessage="numberOfTask-1 === 3 ? 'Объедини общие интересы' : null"
    />
    <div v-if="numberOfTask<4">
      <div :class="[$style.background__left, {[$style.moveToLeft]: rightPartHovering}, {[$style.moveToRight]: leftPartHovering}]"
           :style="{'background-image': 'url(' + require(`@/assets/lesson-1/bg_${numberOfTask}_1.jpg`) + ')'}"
           alt="background"
           @mouseover="leftPartHovering = true"
           @mouseout="leftPartHovering = false"></div>
      <div :class="[$style.background__right, {[$style.moveToLeft]: rightPartHovering}, {[$style.moveToRight]: leftPartHovering}, {[$style.noContain]: numberOfTask===2}]"
           :style="{'background-image': 'url(' + require(`@/assets/lesson-1/bg_${numberOfTask}_2.jpg`) + ')'}"
           alt="background"
           @mouseover="rightPartHovering = true"
           @mouseout="rightPartHovering = false"></div>
      <img :class="[$style.character,$style.characterLeft]"
           :src="require(`@/assets/lesson-1/person_${numberOfTask}_1.svg`)"
           alt="character"
           @mouseover="leftPartHovering = true"
           @mouseout="leftPartHovering = false"/>
      <img :class="[$style.character,$style.characterRight]"
           :src="require(`@/assets/lesson-1/person_${numberOfTask}_2.svg`)"
           alt="character"
           @mouseover="rightPartHovering = true"
           @mouseout="rightPartHovering = false"/>
      <InfoBox :class="$style.infoLeft" :value="info[numberOfTask-1][0]"/>
      <InfoBox :class="$style.infoRight" :value="info[numberOfTask-1][1]"/>
      <DragAndDropTask
        ref="dragAndDropTask"
        :numberOfTask="numberOfTask"
        :taskUnlocked="dragAndDropTaskUnlocked"
        @help="helpBoxType = 'task'"
        @warning="showWarning"
        @success="setSuccessTask"
      />
    </div>
    <ConnectInterestsTask
      v-else
      ref="connectionTask"
      @help="helpBoxType = 'task'"
      @warning="showWarning"
      @success="setSuccessLevel"
      @addPoint="addPoint"
    />
</div>
</template>

<script>
import LevelPopup from '@/components/LevelPopup/LevelPopup'
import InfoBox from '@/components/InfoBox/InfoBox'
import Points from '@/components/Points/Points'
import HelpBox from '@/components/HelpBox/HelpBox'
import DragAndDropTask from '@/components/DragAndDropTask/DragAndDropTask'
import ConnectInterestsTask from '@/components/ConnectInterestsTask/ConnectInterestsTask'

import saveDataMixin from '@/mixins/saveData'

// max 27
export default {
  name: 'lesson1',
  components: {
    ConnectInterestsTask,
    DragAndDropTask,
    HelpBox,
    Points,
    InfoBox,
    LevelPopup,
  },
  mixins: [saveDataMixin],
  data: () => ({
    numberOfTask: 1,
    numberOfPoints: 0,
    pointsPosition: 'center',
    currentPopupId: 0,
    showHelpBox: false,
    dragAndDropTaskUnlocked: false,
    leftPartHovering: false,
    rightPartHovering: false,
    popupList: [
      {
        title: 'Привет!',
        description: 'Нейросети призваны решать сложные аналитические задачи — распознавать лица, предсказывать погоду, рекомендовать покупки и многое другое. Чтобы нейросеть умела выполнять такие задачи, она должна пройти обучение.\n',
      },
      {
        title: 'Обучи нейросеть.',
        description: 'Почувствуй себя специалистом по обучению нейросети. Научи нейросеть подбирать подходящий способ связи между героями с учётом известной информации.',
        steps: ['Познакомься с ситуацией, в которую попали герои.', 'Изучи анкеты двух героев.', 'Выбери подходящий способ связи.'],
      },
      {
        title: 'Обучение нейросети выполнено успешно!',
        description: 'Благодаря тебе нейросеть научилась рекомендовать лучший вариант для общения, исходя из информации, которая известна о героях. Далее ты узнаешь, как нейросети помогают в поиске новых знакомых и друзей.',
      },
      {
        title: 'Рекомендация друзей.',
        description: 'В социальных сетях есть функция рекомендации новых друзей. Нейросеть анализирует пользователей по разным параметрам, в том числе по интересам. На основе этой информации нейросеть предлагает пользователю с кем-то подружиться.',
      },
      {
        title: 'Найди общие интересы.',
        description: 'Почувствуй себя нейросетью: найди всех героев с общими интересами и объедини их.',
        steps: ['Посмотри на интересы героев, указанные в анкете.', 'Объедини героев из верхней и нижней строки.'],
      },
      {
        title: null,
        description: 'Давай подведем итоги урока. Посмотри видео о пройденном сегодня материале про нейросети и коммуникации. Зафиксируй главные мысли и выводы.',
      },
      {
        title: 'Молодец!',
        description: 'Тебе удалось объединить всех героев по интересам и обучить нейросеть рекомендовать друзей.',
      },
    ],
    info: [
      [['продуктовый магазин', 'смартфон', 'быстрая', 'включены'], ['дома в деревне', 'компьютер', 'средняя', 'отключены']],
      [['южная часть парка', 'смартфон', 'быстрая', 'включены'], ['северная часть парка', 'смартфон', 'низкая', 'включены']],
      [['Москва', 'планшет', 'быстрая', 'включены'], ['Санкт-Петербург', 'смартфон', 'быстрая', 'включены']],
    ],
    helpBoxType: 'task',
    helpBoxText: [
      {
        task: 'Помоги нейросети подобрать наилучший способ связи для следующей ситуации:\n'
          + 'Скобец хочет связаться с бабушкой, чтобы узнать, какие продукты нужны для приготовления пирожков. Перетащи нижние иконки в пустую область.\n',
        warning: 'У бабушки в деревне не хватает скорости Интернета для видеозвонока, а текстовые сообщения она не читает, так как отключены уведомления. Выбери другой способ связи.',
        success: 'Молодец! Ты помог Скобцу связаться с бабушкой при помощи аудиозвонка. Теперь нейросеть знает, что порекомендовать в подобном случае!',
      },
      {
        task: 'Помоги нейросети подобрать наилучший способ связи для следующей ситуации:\n'
          + 'помоги братьям Слэшам встретиться друг с другом. Они договорились встретиться в парке, но он большой. \n\n Выбери два возможных способа связи, обрати внимание на технические возможности героев.\n',
        warning: 'У второго брата проблемы с интернетом, плохо работает связь, поэтому голосовое сообщение и видеозвонок не подходят. Выбери другой способ связи.',
        success: 'Молодец! Тебе удалось найти все способы связи и братья смогли найти друг друга. Теперь нейросеть знает, что порекомендовать в подобном случае!',
      },
      {
        task: 'Помоги нейросети подобрать наилучший способ связи для следующие ситуации:\n'
          + 'Запятыня хочет показать новые игрушки своей старшей сестре Марусе. \n\n Выбери три возможных способа связи, обрати внимание на технические возможности героев.\n',
        warning: 'Сёстры находятся в разных городах, аудиозвонок и стикер не подходят для этой ситуации. Выбери другой способ связи.',
        success: 'Молодец! Тебе удалось найти все способы связи и сёстры смогли связаться друг с другом. Теперь нейросеть знает, что порекомендовать в подобном случае!',
      },
      {
        task: 'Объедини пользователей из верхней и нижней строки. Не забывай что между ними должны быть общие интересы.',
        warning: 'Посмотри внимательнее. Есть ли у этих пользователей общие интересы?',
        success: 'Молодец! Тебе удалось найти все способы связи и братья смогли найти друг друга.',
      },
    ],
    customWarning: '',
  }),
  methods: {
    setSuccessTask() {
      this.helpBoxType = 'success'
      setTimeout(() => {
        this.showHelpBox = true
      }, 600)
    },
    showNextTask() {
      this.numberOfPoints += 5
      if (this.numberOfTask === 3) {
        this.currentPopupId = 2
        return
      }
      this.numberOfTask += 1
      this.helpBoxType = 'task'
      setTimeout(() => {
        this.showHelpBox = true
      }, 500)
    },
    initDropTask() {
      if (!this.$refs.dragAndDropTask) return
      this.dragAndDropTaskUnlocked = true
      this.showHelpBox = true
    },
    initConnectionTask() {
      this.numberOfTask = 4
      this.helpBoxType = 'task'
      this.pointsPosition = 'left'
      this.currentPopupId = 3
    },
    getWarningText(res) {
      switch (this.numberOfTask) {
        case 1:
          switch (res.values().next().value) {
            case 'message':
              return 'Бабушка не читает текстовые сообщения, так как отключены уведомления, выбери другой способ связи.'
            case 'videoCall':
              return 'У бабушки в деревне не хватает скорости интернета для видеозвонка, выбери другой способ связи.'
            case 'emoji':
              return 'Бабушка не читает текстовые сообщения, так как отключены уведомления, выбери другой способ связи. '
            default:
              return ''
          }
        case 2: {
          let message = 'У второго брата проблемы с интернетом, плохо работает связь, поэтому '
          let wrongCount = 0
          res.forEach((r) => {
            switch (r) {
              case 'audioCall':
                if (wrongCount > 0) message += 'и '
                message += 'аудиозвонок '
                wrongCount += 1
                break
              case 'videoChat':
                if (wrongCount > 0) message += 'и '
                message += 'видеоклип '
                wrongCount += 1
                break
              case 'videoCall':
                if (wrongCount > 0) message += 'и '
                message += 'видеозвонок '
                wrongCount += 1
                break
              default:
                break
            }
          })
          const letter = wrongCount > 1 ? 'я' : 'и'
          message += `не подход${letter}т. Выбери другой способ связи.`
          return message
        }
        case 3: {
          let message = 'Запятыня хочет показать игрушку своей сестре Марусе, '
          let wrongCount = 0
          res.forEach((r) => {
            switch (r) {
              case 'audioCall':
                if (wrongCount > 0) message += 'и '
                message += 'аудиозвонок '
                wrongCount += 1
                break
              case 'sticker':
                if (wrongCount > 0) message += 'и '
                message += 'стикер '
                wrongCount += 1
                break
              default:
                break
            }
          })
          const letter = wrongCount > 1 ? 'я' : 'и'
          message += `не подход${letter}т для этой ситуации. Выбери другой способ связи.`
          return message
        }
        default: return ''
      }
    },
    showWarning(res) {
      this.customWarning = this.getWarningText(res)
      this.helpBoxType = 'warning'
      setTimeout(() => {
        this.showHelpBox = true
      }, 600)
    },
    closeWarning() {
      if (this.numberOfTask === 4) {
        this.$refs.connectionTask.closeWarning()
      }
    },
    setSuccessLevel() {
      this.currentPopupId = 5
      this.stopTimer()
    },
    addPoint() {
      this.numberOfPoints += 1
    },
    closePopupHandler(id) {
      switch (id) {
        case 0:
          this.currentPopupId = 1
          break
        case 1:
          this.initDropTask()
          break
        case 2:
          this.initConnectionTask()
          break
        case 3:
          this.currentPopupId = 4
          break
        case 4:
          this.showHelpBox = true
          break
        case 5:
          this.currentPopupId = 6
          break
        case 6:
          this.saveData({})
          break
        default:
      }
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.currentPopupId = 0
    // }, 1000)
    this.startTimer()
  },
}
</script>

<style lang="scss" module>
  @import './lesson1.scss';
</style>
